import { StorageLevel } from '../../models/document';

const getEntityStorageDirectory = (
  entity: boolean,
  entityDirectory: string,
  nonEntityDirectory: string
) => (entity ? entityDirectory : nonEntityDirectory);

const getStorageFileDirectory = (
  storageLevel: StorageLevel,
  entityId?: string
) => {
  const isEntity = entityId !== undefined;

  let storageLocation: string;

  switch (storageLevel) {
    case StorageLevel.PRIVATE:
      storageLocation = getEntityStorageDirectory(isEntity, `${entityId}`, '');
      break;
    default:
      throw new Error(`Invalid storage level: ${storageLevel}`);
  }
  return String(storageLocation);
};
export default getStorageFileDirectory;
